import DOMPurify from 'dompurify'

// 纯文本转义
export function escapeHtml(str) {
	return String(str == null ? '' : str)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
}

// 搜索高亮：文本与关键字都先转义，只输出受控的 <span>
export function highlight(text, keyword) {
	const safe = escapeHtml(text)
	if (!keyword) return safe
	const key = escapeHtml(keyword)
	const re = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
	return safe.replace(re, (m) => `<span class="xss-hl">${m}</span>`)
}

// 外链/跳转地址：只允许 http(s) 绝对地址和站内相对路径；伪协议、协议相对地址返回 null
const SCHEME_RE = /^[a-z][a-z0-9+.-]*:/i

export function safeLink(url) {
	const raw = String(url == null ? '' : url).trim()
	if (!raw) return null
	// 浏览器解析 URL 会忽略换行/制表等控制字符，必须整串拒绝，避免 "java\nscript:"
	if (/[\u0000-\u001F\u007F\\]/.test(raw)) return null
	if (/^https?:\/\//i.test(raw)) return raw
	if (raw.startsWith('//')) return null
	if (SCHEME_RE.test(raw)) return null
	return raw
}

// v-html 统一消毒：允许常见富文本标签，去掉脚本/事件属性
export function sanitizeHtml(html) {
	if (html == null || html === '') return ''
	return DOMPurify.sanitize(String(html), {
		FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'meta', 'link'],
		FORBID_ATTR: ['srcdoc']
	})
}